<template>
  <div style="height:100%">
    <router-view v-if="!isKeepAlive"></router-view>
    <keep-alive>
      <router-view v-if="isKeepAlive"></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    routerName() {
      return this.$route.path;
    },
    isKeepAlive() {
      return this.$route.meta && this.$route.meta.keepAlive;
    }
  }
};
</script>
